import { Component, DestroyRef, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CaButtonComponent } from '@global-front-components/ui/button';

@Component({
	selector: 'app-pymes-preguntas-frequentes',
	standalone: true,
	imports: [CommonModule, CaButtonComponent, TranslateModule],
	templateUrl: './pymes-preguntas-frequentes.component.html',
	styleUrls: ['./pymes-preguntas-frequentes.component.scss']
})
export class PymesPreguntasFrequentesComponent implements OnInit {
	title: string = '';
	questions: any[] = [];
	questionRows: any[] = [];

	constructor(
		private location: Location,
		private translateService: TranslateService,
		private destroyRef: DestroyRef
	) { }

	ngOnInit(): void {
		this.loadQuestionsFromTranslations();
	}

	private loadQuestionsFromTranslations(): void {
		this.translateService
			.stream('PYMES.PREGUNTAS-FREQUENTES')
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((data: any) => {
				this.title = data?.TITLE || '';
				this.questions = data?.QUESTIONS || [];
				this.questionRows = this.buildQuestionRows(this.questions);
			});
	}

	private buildQuestionRows(questions: any[]): any[] {
		const half = Math.ceil(questions.length / 2);
		const leftColumn = questions.slice(0, half);
		const rightColumn = questions.slice(half);

		return leftColumn.map((leftQuestion, index) => ({
			left: leftQuestion,
			right: rightColumn[index] || null
		}));
	}

	trackByRow(index: number): number {
		return index;
	}

	trackByBullet(index: number, bullet: string): string {
		return bullet;
	}
}